export default "__VITE_ASSET__DheS9utP__"